import { Box } from '@mui/material'
import React from 'react'
import { getAssetHolderQuery, useGetDashboardQuery } from '../../../../api/asset-holders/assetHolderApi'
import { type AssetHolding } from '../../../../api/schema-dtos/DashboardDomainDtos'
import LoadingComponent from '../../../shared/components/ui-widgets/LoadingComponent'
import ErrorComponent from '../../../shared/components/ui-widgets/ErrorComponent'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import { type AssetHolderIdProps } from '../../pages/DashboardHome'
import SolarProjectListItem from './SolarProjectListItem'

const SolarProjectsList: React.FC<AssetHolderIdProps> = ({ assetHolderId }: AssetHolderIdProps) => {
  const getAssetHolderApiResult = getAssetHolderQuery()
  const getDashboardApiResult = useGetDashboardQuery({ assetHolderId })

  return (
    // px padding here as we have py padding in the parent component
    <>
      <Box sx={{ px: 4 }}>
        {(getDashboardApiResult.isLoading || getAssetHolderApiResult.isLoading) && <LoadingComponent/>}
        {getDashboardApiResult.isError &&
          <ErrorComponent message={RtkQueryHelper.mapResponseError(getDashboardApiResult.error)}/>}
        {getAssetHolderApiResult.isError &&
          <ErrorComponent message={RtkQueryHelper.mapResponseError(getAssetHolderApiResult.error)}/>}
      </Box>

      {getDashboardApiResult.isSuccess && getAssetHolderApiResult.isSuccess && (
        <>
          {/* {getWalletsApiResult.isSuccess && ( */}
          {/*  // <SolarProjectsSummary portfolio={getDashboardApiResult.data} wallets={getWalletsApiResult.data}/> */}
          {/* )} */}

          {getDashboardApiResult.data.assetHoldings.map((assetHolding: AssetHolding) => (
          <SolarProjectListItem key={assetHolding.project.projectId}
                                assetHolder={getAssetHolderApiResult.data}
                                assetHolding={assetHolding}/>
          ))}
        </>
      )}

    </>
  )
}

export default SolarProjectsList
